import React from 'react'
import styled from '@emotion/styled'
import { Link } from 'gatsby'

import CABtn from './CABtn'
var slugify = require('slugify')

const ListCard = styled(Link)`
    position: relative;
    flex-direction: column;
    padding: 16px;
    border-radius: 4px;
    display: flex;
    flex-direction: row;
    border: 1px solid #ddd;
    overflow: hidden;
    img {
    	/*border: 1px solid rgba(0,0,0,.05);*/
	    background-color: rgb(0,0,0,.02);
	    margin: 0 15px 0 0;
	    border-radius: 10%;
      min-width: 30px;
    }
    transition: all .3s cubic-bezier(.215,.61,.355,1);
    &:hover {
    	border: 1px solid rgba(0,0,0,.3);

    }
	h3 {
		color: #222;
		font-size: .9rem;
    margin-bottom: 0;
	}
`

const Tag = styled.div`
  border-radius: 4px;
  max-width: 160px;
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 0.7rem;
  color: rgb(0, 0, 0, 0.6);
  align-items: center;
  margin-bottom: 5px;
  margin-right: 5px;
  transition-duration: 0.2s;
`

const Col = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`

export default ({item}) => (
	<ListCard key={item.name} to={`/${slugify(item.name.toLowerCase())}`}>
		<img src={`/icons/${item.logo}`} height="40px"/>
		<Col>
			<h3>{item.name}</h3>
      <div>
			<Tag>{item.companytype}</Tag>
      <CABtn ca={item.californiaonly} />
      </div>
		</Col>
	</ListCard>
)


